<script lang="ts">
  import validationErrors from '../../../views/shared/mixins/validationErrors'
  export default defineComponent({
    name: 'FooterLayout',
    mixins: [validationErrors]
  })
</script>

<script setup lang="ts">
  import tradutor from '../../../tradutors/mainfooter'
  import translateMain from '../../../tradutors/menu'
  import { localeStore } from '../../../stores/locale'
  import { computed, defineComponent, ref } from 'vue'
  import router from '../../../router'
  import api from '../../../api'
  import { isMobile } from '../../../views/shared/utils/mobile'

  //Icones
  import Telegram from 'assets/img/telegramRedBackBlack.webp'
  import Topfans from 'assets/img/topfansRedBackBlack.webp'
  import Twitter from 'assets/img/twitterRedBackBlack.webp'
  import Whatsapp from 'assets/img/whatsappRedBackBlack.webp'
  //import Youtube from 'assets/img/youtubeRedBackBlack.webp'

  const emits = defineEmits(['showModalMessages'])

  const storeLocale = localeStore()
  const reactiveLocale = computed(() => storeLocale.locale)

  const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return tradutor.portugues
    } else {
      return tradutor.ingles
    }
  })

  const translatemain = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translateMain.portugues
    } else {
      return translateMain.ingles
    }
  })

  const now = computed(() => {
    return new Date().getFullYear()
  })

  const email = ref('')
  const icones = ref([
    { src: Telegram, link: 'https://t.me/belladasemanaoficial' },
    { src: Topfans, link: 'https://topfans.me/bella' },
    //{ src: Youtube, link: 'https://www.youtube.com/channel/UCAjpZH6H-Tqt5JI7F3dPeTA' },
    { src: Twitter, link: 'https://twitter.com/belladasemana' },
    { src: Whatsapp, link: 'https://chat.whatsapp.com/IS3rWOWDnLeIyNQbvDfGdq' }
  ])

  function redirect(name: string) {
    router.push({ name, params: { locale: reactiveLocale.value } })
  }
  function addToNewsletter() {
    api.post('v1/newsletter/storeNewsletterApi?email=' + email.value).then(({ data }) => {
      emits('showModalMessages', {
        message: {
          show: true,
          title: '',
          textBoby: data.return,
          textButton: 'Fechar'
        }
      })
    })
  }
</script>
<template>
  <footer class="l-footer">
    <div class="container">
      <div class="row">
        <div class="col-12 col-xl-3 order-xl-1 d-none d-xl-block">
          <h3>{{ translate.menu.about }}</h3>
          <p class="summary" v-text="translate.menu.footerDescription" />
          <div class="link-about" @click="redirect('AboutPage')">
            {{ translate.menu.btnSeeMore }} <i class="icon-arrow-right"></i>
          </div>
        </div>
        <div v-if="!isMobile()" class="col-12 col-md-6 order-2 col-xl-6 order-xl-2 mt-2">
          <div class="nav">
            <ul class="d-flex">
              <li>
                <a href="#" @click="redirect('FreeTourPage')">
                  {{ translate.menu.freetour }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('ColumnsPage')">
                  {{ translate.menu.colums }}
                </a>
              </li>
              <li>
                <a :href="`/${reactiveLocale}/partners`">
                  {{ translate.menu.parceiro }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('ModelsPage')">
                  {{ translate.menu.modelos }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('EcardsPage')">
                  {{ translate.menu.ecard }}
                </a>
              </li>
              <li>
                <a href="#">
                  {{ translate.menu.edicoes }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('VideosPage')">
                  {{ translate.menu.videos }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('BellaCloudPage')">
                  {{ translate.menu.bellacloud }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('AfiliadosPage')">
                  {{ translate.menu.afiliados }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('BlogsPage')">
                  {{ translate.menu.blog }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('ContactUsPage')">
                  {{ translate.menu.contato }}
                </a>
              </li>
              <li>
                <a href="#">
                  {{ translate.menu.imprensa }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('LivesPage')">
                  {{ translate.menu.lives }}
                </a>
              </li>
              <li></li>
              <li></li>
            </ul>
          </div>
        </div>

        <div v-else class="col-12 order-2 order-xl-2">
          <hr style="margin: 0px 0px 30px" />
          <div class="text-center">
            <ul class="w-100">
              <li>
                <a href="#" @click="redirect('AboutPage')">
                  {{ translate.menu.about }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('PolicyPrivacyPage')">
                  {{ translate.menu.privacidade }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('PolicyCancellationPage')">
                  {{ translate.menu.cancelamento }}
                </a>
              </li>
              <li>
                <a href="#">
                  {{ translate.menu.afiliados }}
                </a>
              </li>
              <li>
                <a :href="`/${locale}/partners`">
                  {{ translate.menu.parceiro }}
                </a>
              </li>
              <li>
                <a href="#">
                  {{ translate.menu.edicoes }}
                </a>
              </li>
              <li>
                <a href="#">
                  {{ translate.menu.imprensa }}
                </a>
              </li>
              <li>
                <a href="#" @click="redirect('ContactUsPage')">
                  {{ translate.menu.contato }}
                </a>
              </li>
            </ul>
          </div>
          <hr style="margin: 50px 0px 30px; color: #333333" />
        </div>
        <div class="col-12 col-md-6 order-1 col-xl-3 order-xl-3 px-3">
          <div class="newsletter">
            <h3 v-if="isMobile" class="newsletter__title" v-text="translate.menu.news2" />
            <h3 v-else class="newsletter__title" v-text="translate.menu.news" />
            <h3 class="newsletter__title-b" v-text="translate.menu.newsDescription"></h3>
            <div class="newsletter__textbox">
              <form @submit.prevent="addToNewsletter">
                <input
                  type="email"
                  name="email"
                  :placeholder="translate.menu.email"
                  required
                  v-model="email"
                  @keyup.enter="addToNewsletter"
                  style="color: #999999"
                />
                <button type="submit" aria-label="Newsletter">
                  <i class="icon-arrow-right"></i>
                </button>
              </form>
            </div>
            <small v-text="translate.menu.emailDescription" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-3">
          <!-- Social Links -->
          <ul class="social-box">
            <li v-for="(icon, index) in icones" :key="index">
              <a :href="icon.link" target="_blank"
                ><img :src="icon.src" alt="Social Link" width="23" height="23" class="icon-header"
              /></a>
            </li>
          </ul>
        </div>
        <div class="col-12 col-xl-9 m-bottom">
          <a @click="redirect('PolicyPrivacyPage')" class="privacy" v-text="translate.menu.privacidade" />
          <a @click="redirect('PolicyCancellationPage')" class="privacy" v-text="translate.menu.cancelamento" />
        </div>
      </div>
      <div class="copy">
        <p>
          © 2001 - {{ now }}. Bella Entretenimento Ltda CNPJ 04.410.756/0001-60.
          {{ translatemain.copia }}.
        </p>
        <p v-text="translate.menu.declaracao"></p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
  h3 {
    color: #ffffff;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 5px;
  }

  .newsletter__textbox input {
    height: 15px;
    color: #ffffff;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 15px;
    position: relative;
    width: 100%;
    height: 100%;
    text-align: start;
    padding: 17px 20px;
    border: none;
    background: none;
    outline: none;
  }

  .link-about {
    cursor: pointer;
  }

  .l-footer .newsletter__title {
    display: block;
  }

  .l-footer .newsletter {
    margin-bottom: -10px;
  }

  .l-footer .copy:before {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .l-footer {
    padding-top: 50px;
  }

  .summary {
    color: #999999;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 15px;
  }

  .l-footer .summary {
    margin-bottom: 5px;
  }

  .link-about {
    color: #999999;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    margin-bottom: 35px;
  }

  .l-footer .nav ul li a {
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .l-footer .nav ul li {
    margin-bottom: 12px;
  }

  .newsletter__title {
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    margin-top: 12px;
  }

  .newsletter small {
    color: #999999;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 15px;
  }

  .copy p {
    color: #999999;
    font-family: 'Roboto-Regular';
    font-size: 11px;
    letter-spacing: 0;
    line-height: 13px;
  }

  .order-xl-1 {
    margin-top: 3px;
    padding-left: 14px;
  }

  .social-box {
    margin-left: -7px;
  }

  .l-footer .social-box li {
    margin-right: 10px;
  }

  .privacy {
    color: #999999;
    cursor: pointer;    
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .l-footer {
      padding-top: 0px;
    }

    .newsletter__title {
      color: #ffffff;
      font-family: 'Roboto-Medium';
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 28px;
    }

    .newsletter__title-b {
      margin-bottom: 5px;
    }

    .newsletter small {
      color: #999999;
      font-family: 'Roboto-Regular';
      font-size: 13px;
      letter-spacing: 0;
      line-height: 15px;
      margin-bottom: 50px;
    }

    .copy p {
      color: #999999;
      font-family: 'Roboto-Regular';
      font-size: 13px;
      letter-spacing: 0;
      line-height: 15px;
    }

    .l-footer ul li a {
      display: block;
      height: 19px;
      color: #ffffff;
      font-family: 'Exo-2';
      font-size: 16px;
      letter-spacing: 0;
      line-height: 19px;
      padding: 25px 0px;
    }

    .l-footer .privacy:first-child {
      margin-right: 30px; 
    }  
    .m-bottom{
      margin-bottom: 50px;
    }    
  }
</style>
